import { useEffect } from 'react';
import { useSearchParams } from 'react-router';
import { AccessOrigin, BranchStorageValue } from '../../types/branch';
import { getBranchEventTag, isValidBranch } from '../../utils/branch';
import { sendEvent } from '../../../../core/services/firebase/analytics';

const BRANCH_STORAGE_KEY = 'sac-loja:branch';
const BRANCH_TIMESTAMP_STORAGE_KEY = 'sac-loja:branch-timestamp';

function getStoredBranchValue(): BranchStorageValue | null {
  const branch = localStorage.getItem(BRANCH_STORAGE_KEY);
  const timestamp = Number(localStorage.getItem(BRANCH_TIMESTAMP_STORAGE_KEY));

  if (!branch || !timestamp) {
    return null;
  }

  return { branch, timestamp };
}

function isSameDay(timestamp: number): boolean {
  return new Date(timestamp).toDateString() === new Date().toDateString();
}

function clearStoredBranchValue(): void {
  localStorage.removeItem(BRANCH_STORAGE_KEY);
  localStorage.removeItem(BRANCH_TIMESTAMP_STORAGE_KEY);
}

function sendToFirebase(value: AccessOrigin): void {
  sendEvent(getBranchEventTag(value));
}

export const useBranchFromQuery = (): void => {
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const branchFromQuery = searchParams.get('branch');

    if (branchFromQuery) {
      if (isValidBranch(branchFromQuery)) {
        localStorage.setItem(BRANCH_STORAGE_KEY, branchFromQuery);
        localStorage.setItem(BRANCH_TIMESTAMP_STORAGE_KEY, String(Date.now()));
        sendToFirebase(branchFromQuery);
      }
      return;
    }

    const storedBranchValue = getStoredBranchValue();

    if (!storedBranchValue || !isSameDay(storedBranchValue.timestamp)) {
      clearStoredBranchValue();
    }
  }, [searchParams]);
};
